import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=3df8a7da"
import script from "./Template.ts?vue&type=script&lang=ts&external"
export * from "./Template.ts?vue&type=script&lang=ts&external"
import style0 from "./templates.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports